import TaskTable from './TaskTable';

export default {
	TaskTable
};

export { TaskTable };
